// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2KerO","head":"ProcedureTableInfo_head__2VaiF"};